require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 327
// module chunks = 0